/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Gamepad_Mode_IndependentInputs */



/**
* | output |
* | --- |
* | "Independent buttons (Philips Footcontrol)" |
*
* @param {Options_Pedal_Gamepad_Mode_IndependentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_gamepad_mode_independent = /** @type {((inputs?: Options_Pedal_Gamepad_Mode_IndependentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Gamepad_Mode_IndependentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Independent buttons (Philips Footcontrol)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Independent buttons (Philips Footcontrol)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Independent buttons (Philips Footcontrol)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Independent buttons (Philips Footcontrol)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Independent buttons (Philips Footcontrol)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Independent buttons (Philips Footcontrol)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Independent buttons (Philips Footcontrol)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Independent buttons (Philips Footcontrol)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Independent buttons (Philips Footcontrol)")
	return /** @type {LocalizedString} */ ("Independent buttons (Philips Footcontrol)")
});